import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layoutName: 'default',
    activeTitle: '',
    isLoading: true,
    statusesMaster: [],
    deadStatusIds: [],
    deadReasons: [],
    cities: [],
  },
  mutations: {
    setLayout(state, layout){
      state.layoutName = layout
    },
    setActiveTitle(state, title){
      state.activeTitle = title
    },
    setLoading(state, isLoading){
      state.isLoading = isLoading
    },
    setStatusesMaster(state, statuses){
      state.statusesMaster = statuses
    },
    setDeadStatusIds(state, statusIds){
      state.deadStatusIds = statusIds
    },
    setDeadReasons(state, reasons){
      state.deadReasons = reasons;
    },
    setCity(state, city){
      state.cities = city;
    },
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setActiveTitle({commit}, title){
      commit('setActiveTitle', title);
    },
    setLoading({commit}, isLoading){
      commit('setLoading', isLoading);
    },
    setStatusesMaster({commit}, statuses){
      commit('setStatusesMaster', statuses)
    },
    setDeadStatusIds({commit}, statusIds){
      commit('setDeadStatusIds', statusIds)
    },
    setDeadReasons({commit}, reasons){
      commit('setDeadReasons', reasons);
    },
    setCity({commit}, city){
      commit('setCity', city);
    },

  },
  getters: {
    layout(state){
      return state.layoutName;
    },
    activeTitle(state){
      return state.activeTitle;
    },
    isLoading(state){
      return state.isLoading;
    },
    statusesMaster(state){
      return state.statusesMaster;
    },
    deadStatusIds(state){
      return state.deadStatusIds;
    },
    deadReasons(state){
      return state.deadReasons;
    },
    cities(state){
      return state.cities;
    },
  }
})
